/* WF · 产品页模板脚本 2026-10-08：评论正文超过 4 行折叠，点 Read more 展开 */
(function () {
  if (window.__wfPdp) return;
  window.__wfPdp = true;
  function setup() {
    if (!document.querySelector('.wf-pdp')) return;
    document.querySelectorAll('.jdgm-review-widget .jdgm-rev').forEach(function (rev) {
      if (rev.dataset.wfMore) return;
      var body = rev.querySelector('.jdgm-rev__body');
      if (!body || !body.offsetParent) return;
      rev.dataset.wfMore = '1';
      body.classList.add('wf-clamp');
      if (body.scrollHeight <= body.clientHeight + 4) { body.classList.remove('wf-clamp'); return; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wf-rv-more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('wf-clamp') === false;
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      body.insertAdjacentElement('afterend', btn);
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(setup, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 10/8 买家照片墙：点图片放大看（主题 gallery 区块，只在新模板产品页生效） */
(function(){if(window.__wfLb)return;window.__wfLb=1;function wfLb(){
  if(!document.querySelector('.wf-pdp'))return;
  var grid=document.querySelector('ul.gallery');if(!grid)return;
  var imgs=[].slice.call(grid.querySelectorAll('.gallery__card img'));if(!imgs.length)return;
  var dlg=document.createElement('dialog');dlg.className='wf-lb';dlg.setAttribute('aria-label','Customer photo');
  dlg.innerHTML='<button type="button" class="wf-lb__x" aria-label="Close">×</button><button type="button" class="wf-lb__nav wf-lb__prev" aria-label="Previous photo">‹</button><img alt=""><button type="button" class="wf-lb__nav wf-lb__next" aria-label="Next photo">›</button>';
  document.body.appendChild(dlg);
  var big=dlg.querySelector('img'),cur=0;
  function src(i){var s=i.currentSrc||i.src;return s.replace(/([?&])width=\d+/,'$1width=1200');}
  function show(n){cur=(n+imgs.length)%imgs.length;var i=imgs[cur];big.src=src(i);big.alt=i.alt||'';}
  imgs.forEach(function(i,n){var card=i.closest('.gallery__card');card.style.cursor='zoom-in';card.setAttribute('tabindex','0');card.setAttribute('role','button');
    function open(e){e.preventDefault();show(n);if(dlg.showModal)dlg.showModal();}
    card.addEventListener('click',open);card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')open(e);});});
  dlg.querySelector('.wf-lb__x').addEventListener('click',function(){dlg.close();});
  dlg.querySelector('.wf-lb__prev').addEventListener('click',function(){show(cur-1);});
  dlg.querySelector('.wf-lb__next').addEventListener('click',function(){show(cur+1);});
  dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close();});
  dlg.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')show(cur-1);if(e.key==='ArrowRight')show(cur+1);});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wfLb);else wfLb();
})();
